export default __webpack_public_path__ + "static/media/cnpj-modelo.ccf9eaf7.png";